/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { PatientDto } from './PatientDto';
import {
    PatientDtoFromJSON,
    PatientDtoFromJSONTyped,
    PatientDtoToJSON,
    PatientDtoToJSONTyped,
} from './PatientDto';

/**
 * 
 * @export
 * @interface PatientListResponseDto
 */
export interface PatientListResponseDto {
    /**
     * List of patients
     * @type {Array<PatientDto>}
     * @memberof PatientListResponseDto
     */
    patients: Array<PatientDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof PatientListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the PatientListResponseDto interface.
 */
export function instanceOfPatientListResponseDto(value: object): value is PatientListResponseDto {
    if (!('patients' in value) || value['patients'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function PatientListResponseDtoFromJSON(json: any): PatientListResponseDto {
    return PatientListResponseDtoFromJSONTyped(json, false);
}

export function PatientListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patients': ((json['patients'] as Array<any>).map(PatientDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function PatientListResponseDtoToJSON(json: any): PatientListResponseDto {
    return PatientListResponseDtoToJSONTyped(json, false);
}

export function PatientListResponseDtoToJSONTyped(value?: PatientListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patients': ((value['patients'] as Array<any>).map(PatientDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

